import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { UNITS } from "../../lib/site";

export const BusinessUnits = () => {
  return (
    <section
      id="empresas"
      data-testid="business-units-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <span className="overline">Empresas do grupo</span>
            <h2 className="font-display mt-4 text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.08]">
              Quatro unidades, uma operação{" "}
              <span className="text-white/60 italic font-light">coesa</span>.
            </h2>
          </div>
          <p className="text-[15px] text-[#b3b0c2] max-w-md">
            Cada unidade atua com autonomia técnica e compartilha a mesma exigência de qualidade
            e execução do Grupo Nexus.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {UNITS.map((u, idx) => {
            const commonProps = {
              "data-testid": `unit-card-${u.id}`,
              className:
                "nx-rainbow-border relative overflow-hidden rounded-[24px] border border-white/10 bg-[#0A0810] group transition-transform duration-500 hover:-translate-y-1 cursor-pointer block focus:outline-none focus:ring-2 focus:ring-white/30",
            };
            const inner = (
              <>
                <div
                  className="relative h-[300px] md:h-[340px] bg-cover bg-center"
                  style={{ backgroundImage: `url(${u.image})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10" />
                  <div className="absolute top-5 left-5 flex items-center gap-2 rounded-full border border-white/15 bg-black/50 backdrop-blur px-3 py-1">
                    <span className="text-[10px] uppercase tracking-[0.22em] text-white/70">
                      Unidade 0{idx + 1}
                    </span>
                  </div>
                  <div className="absolute top-5 right-5">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-black/50 backdrop-blur transition-transform group-hover:rotate-45">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                </div>

                <div className="p-7 md:p-8">
                  <div className="flex items-center gap-2">
                    <h3 className="font-display text-2xl md:text-[28px] text-white font-medium">
                      {u.name}
                    </h3>
                    {u.external && (
                      <span className="text-[10px] uppercase tracking-[0.18em] text-white/45 border border-white/10 rounded-full px-2 py-0.5">
                        Site externo
                      </span>
                    )}
                  </div>
                  <div className="mt-1 text-[12px] uppercase tracking-[0.2em] text-white/55">
                    {u.tagline}
                  </div>
                  <p className="mt-5 text-[15px] text-[#b3b0c2] leading-relaxed">{u.description}</p>

                  <ul className="mt-6 flex flex-wrap gap-2">
                    {u.bullets.map((b) => (
                      <li
                        key={b}
                        className="text-[12px] rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 text-white/75"
                      >
                        {b}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-6 inline-flex items-center gap-2 text-[13px] font-medium text-white/90 group-hover:text-white">
                    {u.external ? "Visitar site" : "Saber mais"}
                    <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                </div>
              </>
            );

            return u.external ? (
              <a
                key={u.id}
                href={u.link}
                target="_blank"
                rel="noreferrer noopener"
                {...commonProps}
              >
                {inner}
              </a>
            ) : (
              <Link key={u.id} to={u.link} {...commonProps}>
                {inner}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BusinessUnits;
